import { useEffect, useLayoutEffect, type DependencyList, type EffectCallback } from "react";

/**
 * `useEffect` の汎用ラッパー（挙動は useEffect と完全に同一）。
 * 専用フック（useMount / useEventListener など）に当てはまらない、
 * 依存配列に追従して外部と同期する副作用に使う最後の逃げ道。
 */
export const useSyncEffect = (effect: EffectCallback, deps: DependencyList): void => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, deps);
};

/**
 * `useLayoutEffect` の汎用ラッパー。
 * DOM 計測やレイアウト確定前に同期的に実行したい副作用に使う。
 */
export const useLayoutSyncEffect = (effect: EffectCallback, deps: DependencyList): void => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(effect, deps);
};
